import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=c71b4a1c&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=c71b4a1c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71b4a1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c71b4a1c')) {
      api.createRecord('c71b4a1c', component.options)
    } else {
      api.reload('c71b4a1c', component.options)
    }
    module.hot.accept("./UserCard.vue?vue&type=template&id=c71b4a1c&scoped=true", function () {
      api.rerender('c71b4a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Users/UserCard.vue"
export default component.exports